import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Container, Column, Row } from '@iag-packages/chroma-react/lib/layouts';

import {
  Link,
  List,
  ListItem,
  Accordion,
  AccordionItem,
} from 'components/chroma';

import { FlybuysInfoSection } from 'scenes/common/components/FlybuysInfo/FlybuysInfoSection';
import QuoteNumberCard from 'scenes/common/components/QuoteInformation/QuoteNumberCards/QuoteNumberCard';
import MarketingCampaign from 'scenes/common/components/MarketingCampaign/MarketingCampaign';

import { FooterTopProps } from './types';

const LinkTrayListContainer = styled.div`
  margin-left: 1rem;
`;

const ImportantInformationContent: FunctionComponent<Pick<
  FooterTopProps,
  'informationLinks'
>> = ({ informationLinks }) => (
  <LinkTrayListContainer>
    <List>
      {informationLinks.map((link) => (
        <ListItem keyProp={`${link.url}`} key={`${link.url}`}>
          <Link href={link.url} target="_blank" rel="noopener noreferrer">
            {link.text}
          </Link>
        </ListItem>
      ))}
    </List>
  </LinkTrayListContainer>
);

const FooterTopMobile: FunctionComponent<FooterTopProps> = ({
  quoteNumber,
  campaign,
  showQuoteInformation,
  pageNotLoadingOrError,
  showFlybuys: showFlybuysInfoSection,
  showFooterQuoteInformation,
  showMarketingCampaign: showFooterMarketingCampaign,
  additionalComponents,
  informationLinks,
  insuranceName,
  saveOnlineInformation,
  awardsToDisplay,
  initialAccordionActiveItems,
  isBeforeEffectiveEndDate,
}) => {
  const hasAdditionalComponents =
    additionalComponents && additionalComponents.length > 0;

  return (
    <Container>
      {showFlybuysInfoSection && pageNotLoadingOrError && (
        <Row justifyContent="center">
          <Column xs={12} md={6}>
            <FlybuysInfoSection insuranceName={insuranceName} />
          </Column>
        </Row>
      )}
      {showFooterQuoteInformation && showQuoteInformation && (
        <Row>
          <Column xs={12} md={10} mdOffset={1}>
            <QuoteNumberCard
              quoteNumber={quoteNumber}
              isBeforeEffectiveEndDate={isBeforeEffectiveEndDate}
            />
          </Column>
        </Row>
      )}
      {showFooterMarketingCampaign && showQuoteInformation && (
        <Row>
          <Column xs={12} md={10} mdOffset={1}>
            <MarketingCampaign quoteNumber={quoteNumber} campaign={campaign} />
          </Column>
        </Row>
      )}
      {awardsToDisplay && (
        <Row margin={{ bottom: 5 }}>
          <Column xs={12} md={6} mdOffset={3}>
            {awardsToDisplay.map((Award) => (
              <Award />
            ))}
          </Column>
        </Row>
      )}
      {showQuoteInformation && (
        <Container>
          <Row>
            <Column xs={12} md={6} mdOffset={3} margin={{ bottom: 5 }}>
              <Accordion>
                {hasAdditionalComponents ? (
                  additionalComponents?.map(({ text, component }) => (
                    <AccordionItem
                      activeItems={
                        initialAccordionActiveItems !== undefined
                          ? initialAccordionActiveItems
                          : undefined
                      }
                      key={text}
                      label={{ text }}
                      content={{ component }}
                    />
                  ))
                ) : (
                  <></>
                )}
                <AccordionItem
                  label={{ text: 'Important Information' }}
                  content={{
                    component: (
                      <ImportantInformationContent
                        informationLinks={informationLinks}
                      />
                    ),
                  }}
                />
              </Accordion>
            </Column>
          </Row>
        </Container>
      )}
      {saveOnlineInformation && (
        <Row>
          <Column xs={12} md={10} mdOffset={1}>
            {saveOnlineInformation}
          </Column>
        </Row>
      )}
    </Container>
  );
};

export default FooterTopMobile;
